import React, {useState} from 'react';
import * as S from './FaqBlock.styles';

import IconSelector from '@ibibo/icon-selector';

const FAQ_DATA = [{
  q: 'What is My-Cash?',
  a: 'My Cash is digital money that you can utilize from your online wallet. You can add it via recharge or receive it as a refund and use it to make transactions on the myPartner platform only.'
},{
  q: 'What is Promo Cash?',
  a: 'Promo Cash is the amount given by myPartner through an offer or marketing activity.'
},{
  q: 'What is the validity of Promo Cash?',
  a: 'Promo Cash always comes with a validity date. This validity can vary based on the construct of the marketing activity it was earned from.'
},{
  q: 'Can I transfer My-Cash to my bank account?	',
  a: 'No, once money is added in the wallet it can not be transferred back to the a bank account.'
},{
  q: 'How do I use Promo Cash?',
  a: 'Promo Cash will be automatically applied in each transaction. If the discount is already high for a transaction, the Promo Cash value may be capped.'
},
{
  q: 'What is the validity of My Cash?',
  a: 'My Cash added to your online wallet through recharge or received as a refund has no expiry. However, My Cash offered as a reward or cashback may or may not have a validity period.'
}
/**
 * The offer is removed for now, might be later added for other early burd offers
{
  q: 'What is the myPartner Early Bird Offer?',
  a: 'On successful registration, Rs. 500 will be credited once as Promo Cash to the myPartner wallet and it will have a validity of 14 days. Also, 10 lucky registered partners will each have Rs. 5000 credited as Promo Cash, it will have a validity of 90 days, lucky draw results will be announced after the offer validity period. The offer is valid till 15th September, 2020.',
}*/

];

const FaqBlock = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return(
    <S.FaqMainWrap>
      <S.FaqHeadingText>FAQs</S.FaqHeadingText>
      <S.FaqOuterWrap>
        <S.FaqInnerWrapList>
          {FAQ_DATA.map((item, i) => <li key={`faq${i}`} onClick={() => setActiveIndex(i)}>
            <S.FaqHeadWrap>
              <S.FaqHeadText>{item.q}</S.FaqHeadText>
              <IconSelector iconKey={i === activeIndex ? 'upbluearrow' : 'downbluearrow'} />
            </S.FaqHeadWrap>
            <S.FaqDetailWrap active={i === activeIndex}>
              <S.FaqDetailText>{item.a}</S.FaqDetailText>
            </S.FaqDetailWrap>
          </li>)}
        </S.FaqInnerWrapList>
      </S.FaqOuterWrap>
    </S.FaqMainWrap>
  );
}

export default FaqBlock;